import { Pipe, PipeTransform } from '@angular/core';

type unit = 'bytes' | 'KB' | 'MB' | 'GB' | 'TB' | 'PB';
type unitPrecisionMap = {
  [u in unit]: number;
};

const defaultPrecisionMap: unitPrecisionMap = {
  bytes: 0,
  KB: 0,
  MB: 1,
  GB: 1,
  TB: 2,
  PB: 2,
};

@Pipe({
  name: 'bytesToReadableUnits',
  standalone: false,
})
export class BytesToReadableUnitsPipe implements PipeTransform {
  private readonly units: unit[] = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

  transform(bytesInput: number = 0, precision: number | unitPrecisionMap = defaultPrecisionMap): string {
    let bytes: number = bytesInput;
    if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) {
      return '?';
    }

    let unitIndex = 0;

    while (bytes >= 1024) {
      bytes /= 1024;
      unitIndex++;
    }

    const unit: unit = this.units[unitIndex];

    if (typeof precision === 'number') {
      return `${bytes.toFixed(Number(precision))} ${unit}`;
    }
    return `${bytes.toFixed(precision[unit])} ${unit}`;
  }
}
